import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";

import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState } from "react";
import { FilterBar } from "./components/FilterBar";
import { LicenseChecksGrid } from "./components/LicenseChecksGrid";
import useLatestLicenseChecks from "./hooks/useLatestLicenseChecks";

export default function LicenseCheckAdminPage() {
  const [results, setResults] = useState<string[]>([]);
  const [userTypes, setUserTypes] = useState<string[]>([]);
  const [user, setUser] = useState<string>();
  const [detailedView, setDetailedView] = useState(false);
  const {
    data: latestLicenseChecks,
    refetch,
    isLoading,
  } = useLatestLicenseChecks({
    results,
    userTypes,
    detailedView,
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));

  return (
    <Stack sx={{ height: "100%" }}>
      <FilterBar
        isMobile={isMobile}
        onUserTypeChange={setUserTypes}
        onResultChange={setResults}
        onUserChange={setUser}
        refresh={refetch}
        detailedView={detailedView}
        toggleDetailedView={() => setDetailedView(!detailedView)}
      />
      <Divider />
      <LicenseChecksGrid
        detailedView={detailedView}
        loading={isLoading}
        data={
          user ? latestLicenseChecks.filter(check => check.userId === user) : latestLicenseChecks
        }
      />
    </Stack>
  );
}
